import React, { useContext, useEffect, useRef, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import AppIcons from '../../icons';
import ToolbarIcons from '../../icons/toolbar';
import AppInput from '../AppInput';
import AppSearch from '../AppSearch';
import CenterModal from '../CenterModal';
import HeaderMoreBox from '../HeaderMoreBox';
import LanguageBox from '../LanguageBox';
import SettingModal from '../SettingModal';
import ThemeBox from '../ThemeBox';
import TooltipBottom from '../TooltipBottom';
import styles from './styles.module.css';

const SettingPart = ({
  content,
  exitFunction,
  showExitButton = false,
  setShowFiles,
  showFiles,
  setShowAbsolute,
}) => {
  const {
    themeColor,
    direction,
    showSearch,
    setShowSearch,
    setActiveMessage,
    setActiveAudio,
    openMenu,
    setOpenMenu,
    showUsers,
    setShowUsers,
    openSettingModal,
    setOpenSettingModal,
    isLogin,
    setActiveUser,
    activeUser,
    setUserChannelId,
    userChannelId,
    setSeekValue,
    setPlaying,
    searchValue,
    setSearchValue,
    userInfo,
    setTrigger,
  } = useContext(AdminContext);
  const [showThemeModal, setShowThemeModal] = useState(false);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [openSettingMore, setOpenSettingMore] = useState(false);
  const languageRef = useRef();
  const themeRef = useRef();
  const settingMore = useRef();

  const checkIfClickedOutsideMore = (e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (
      openSettingMore &&
      settingMore.current &&
      !settingMore.current.contains(e.target)
    ) {
      setOpenSettingMore(false);
      console.log('firstdepen');
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutsideMore);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutsideMore);
    };
  }, [openSettingMore]);

  const checkIfClickedOutsideLanguage = (e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (
      showLanguageModal &&
      languageRef.current &&
      !languageRef.current.contains(e.target)
    ) {
      setShowLanguageModal(false);
      console.log('firstdepen');
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutsideLanguage);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutsideLanguage);
    };
  }, [showLanguageModal]);
  const checkIfClickedOutside = (e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (
      showThemeModal &&
      themeRef.current &&
      !themeRef.current.contains(e.target)
    ) {
      setShowThemeModal(false);
      console.log('firstdepen');
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [showThemeModal]);

  const onFocusSearch = () => {
    // setActiveUser();
    // setUserChannelId();
    // setShowSearch(true);
    // setActiveMessage('');
    // setSeekValue(0);
    // setPlaying(false);
    // setActiveAudio();
  };
  const onCloseFunction = () => {
    setShowSearch(false);
    setShowFiles(false);
    setUserChannelId('');
    setActiveUser();
    // setActiveMessage('');
    // setActiveAudio();
  };
  useEffect(() => {
    if (searchValue?.trim()?.length != 0) {
      setActiveUser();
      setUserChannelId();
      setShowSearch(true);
    } else {
      console.log('aaaa', activeUser, userChannelId);
      if (userChannelId == undefined && activeUser == undefined) {
        onCloseFunction();
      } else {
        setShowSearch(false);
        setShowFiles(false);
      }
      // setShowSearch(false);
    }
  }, [searchValue]);
  return (
    <div
      className={`flex flex-row  justify-start items-center ${
        showFiles ? 'w-auto' : 'w-full'
      } h-auto relative`}
    >
      <AppSearch
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        autoFocus={false}
        onFocus={onFocusSearch}
        inputClassName={`w-full`}
        onCloseFunction={onCloseFunction}
      />
      {/* )} */}
      {isLogin && (
        <TooltipBottom
          // text={content.languages}
          className={` cursor-pointer h-[24px] ${styles.setting}`}
          onClick={() => {
            setShowLanguageModal(false);
            setShowThemeModal(false);
            // setOpenSettingMore(!openSettingMore);
            setOpenSettingModal(!openSettingModal);
          }}
        >
          <AppIcons.SettingsIcon
            fill={'#999'}
            className="flex flex-col justify-center items-center rotate-[180]"
            width={'22px'}
            height={'22px'}
          />
        </TooltipBottom>
      )}
      {openSettingMore && (
        <div
          className={`${styles.menuAbsoluteBox}  themeBox ${
            direction == 'rtl' ? styles.rtlLeft : styles.ltrRight
          }  ${openSettingMore ? 'flex' : 'hidden'}`}
          ref={settingMore}
        >
          <HeaderMoreBox
            content={content}
            exitFunction={exitFunction}
            showExitButton={true}
            setShowFiles={setShowFiles}
            showFiles={showFiles}
            setOpenSettingMore={setOpenSettingMore}
            setShowThemeModal={setShowThemeModal}
            setShowLanguageModal={setShowLanguageModal}
          />
        </div>
      )}
      <TooltipBottom
        // text={content.search}
        className={` cursor-pointer h-[24px] ${styles.refreshIcon}`}
        onClick={() => {
          window.location.reload();
        }}
      >
        <ToolbarIcons.RefreshIcon
          fill={'#999'}
          className="flex flex-col justify-center items-center rotate-[180]"
          width={'22px'}
          height={'22px'}
        />
      </TooltipBottom>
      {userInfo?.levelManage == 3 && (
        <TooltipBottom
          // text={content.search}
          className={` cursor-pointer h-[24px] ${styles.user}`}
          onClick={() => {
            setTrigger('userDashboard');
          }}
        >
          <ToolbarIcons.userIcon
            fill={'#999'}
            className="flex flex-col justify-center items-center rotate-[180]"
            width={'22px'}
            height={'22px'}
          />
        </TooltipBottom>
      )}
    </div>
  );
};

export default SettingPart;
